import { FC } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ArtistCard from "./components/ArtistCard";
import ArtistCustomButtonGroup from "./components/ArtistCustomButtonGroup";
import { TArtist } from "../../types/artists";

type Props = {
  title: string;
  artists: TArtist[];
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 7.1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 6.5,
  },
  "2xl": {
    breakpoint: { max: 768, min: 650 },
    items: 4.2,
  },
  xl: {
    breakpoint: { max: 650, min: 500 },
    items: 3.7,
  },
  lg: {
    breakpoint: { max: 500, min: 448 },
    items: 3.6,
  },
  md: {
    breakpoint: { max: 448, min: 420 },
    items: 3,
  },
  sm: {
    breakpoint: { max: 420, min: 390 },
    items: 3,
  },
  xs: {
    breakpoint: { max: 390, min: 370 },
    items: 3,
    paritialVisibilityGutter: 0,
  },
  sx: {
    breakpoint: { max: 370, min: 0 },
    items: 2.7,
  },
};

const MAX_ITEMS_DESKTOP = 7;

const Artists: FC<Props> = ({ title, artists }) => {
  if (!artists.length) return null;

  return (
    <>
      <div className="pt-[2rem]">
        <h4 className="text-xl text-black font-bold">{title}</h4>
      </div>

      <div className="w-full overflow-hidden">
        {artists.length < MAX_ITEMS_DESKTOP ? (
          <div className="flex justify-center gap-4">
            {artists.map((artist, index) => (
              <ArtistCard
                key={index}
                icon={artist.imgPath}
                artistName={artist.name}
                artistDescription={artist.description}
                link={artist.publicUrl}
              />
            ))}
          </div>
        ) : (
          <Carousel
            itemAriaLabel={"0"}
            arrows={false}
            customButtonGroup={
              <ArtistCustomButtonGroup
                responsive={responsive}
                artists={artists}
              />
            }
            slidesToSlide={1}
            additionalTransfrom={0}
            autoPlaySpeed={3000}
            centerMode={false}
            draggable
            focusOnSelect={false}
            infinite
            keyBoardControl
            minimumTouchDrag={100}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            className="max-w-screen md:pl-7"
            autoPlay={true}
            rewind={false}
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={false}
            swipeable
            itemClass="image-item"
            responsive={responsive}
            removeArrowOnDeviceType={[
              "sx",
              "xs",
              "sm",
              "md",
              "lg",
              "xl",
              "2xl",
            ]}
          >
            {artists.map((artist, index) => (
              <ArtistCard
                key={index}
                icon={artist.imgPath}
                artistName={artist.name}
                artistDescription={artist.description}
                link={artist.publicUrl}
              />
            ))}
          </Carousel>
        )}
      </div>
    </>
  );
};

export default Artists;
